import {Alert, AlertTitle} from "@mui/material";
import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {useStores} from "../../../../../stores";
import moment from "moment";
import {noop} from "rxjs";
import {notificationStore} from "../../../../../stores/init";
import {NotificationStore} from "../../../../../stores/NotificationStore";

export const ApprovalProcessingAlert: React.FC = observer(() => {
    const {categorizationReviewStore} = useStores();
    const estimate = categorizationReviewStore.statusDelegate.categorizationEstimate;

    // Triggers re-initialize
    const [received, setReceived] = React.useState<Date | undefined>(undefined);
    const showAlert = estimate && received;

    useEffect(() => {
        if(estimate?.remaining_seconds) {
            setReceived(new Date());
        } else {
            setReceived(undefined);
        }
    }, [estimate?.remaining_seconds]);

    // Triggers re-render
    const [tick, setTick] = React.useState<number>(0);
    useEffect(() => {
        if(!received) return noop;
        const t = setInterval(() => setTick(tick + 1), 1000);
        return () => {
            setTick(0)
            clearInterval(t)
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [received]);

    useEffect(() => {
        if(showAlert) {
            notificationStore.temporaryHide(NotificationStore.CATEGORIZATION_MSG_ID);
        } else {
            notificationStore.temporaryUnHide(NotificationStore.CATEGORIZATION_MSG_ID);
        }
        return () => {
            // When this component is unmounted
            notificationStore.temporaryUnHide(NotificationStore.CATEGORIZATION_MSG_ID);
        }
    }, [showAlert]);

    if(!showAlert) return <></>;

    const estCompletionTime = moment(received).to(moment(received).add(estimate.remaining_seconds, 'seconds'));
    return <Alert severity="warning">
        <AlertTitle>
            {estimate.n_busy_requests > 1
                ? `${estimate.n_busy_requests} approval requests are still being processed`
                : `An approval requests is still being processed`
            }
        </AlertTitle>
        This page might not be up to date.
        Estimated completion time: {estCompletionTime}
    </Alert>
});
